<template>
  <v-dialog full-width :value="true" persistent>
    <v-container
      color="rgba(0, 0, 0, 0.9)"
      id="video-slide-component"
      :style="classes.videoContainer"
      elevation-12
    >
      <video-player
        class="video-player-custom"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        customEventName="customEvent"
        @statechanged="playerStateChanged($event)"
      ></video-player>
      <v-layout absolute mt-4 px-2 justify-space-between>
        <v-layout d-flex mr-2 xs6>
          <v-btn class="button-border-beige-sm" flat block color="#D6B682" @click.stop="goBack">
            back
            <v-icon color="#D6B682" size="20" class="ml-2">undo</v-icon>
          </v-btn>
        </v-layout>
        <v-layout d-flex xs6>
          <v-btn
            class="button-border-beige-sm"
            block
            flat
            size="20"
            color="#D6B682"
            @click.stop="goForward"
          >Answer</v-btn>
        </v-layout>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import backButton from "../../assets/directions/back_button.png";

export default {
  name: "video-component",
  components: {
    videoPlayer
  },
  props: {
    step: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentDialogIndex: {
      type: Number,
      default: () => 0
    },
    width: {}
  },
  data() {
    return {
      backButton,
      fullscreen: false,
      classes: {
        videoContainer: {
          top: window.innerHeight / 2 - 350 / 2 - 15 + "px"
        }
      },
      playerOptions: {
        // videojs options
        // width: window.innerWidth - 30,
        muted: false,
        autoplay: true,
        language: "en",
        controlBar: {
          fullscreenToggle: false
        },
        fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: this.step.videoFile.url
          }
        ]
      }
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  mounted() {
    this.testing();
  },
  beforeDestroy() {},
  methods: {
    testing() {
      console.log("hello");
    },
    goFullscreen(e) {
      this.player.requestFullscreen();
      this.fullscreen = true;
    },
    goBack() {
      this.$store.dispatch("decrementStep");
    },
    goForward() {
      this.$store.dispatch("incrementStep");
    },
    replayVideo() {
      this.player.currentTime(0);
      this.player.play();
    },
    customEvent(e) {
      console.log(e);
    },
    // listen event
    onPlayerPlay(player) {
      console.log("player play!", player);
    },
    onPlayerPause(player) {
      console.log("player pause!", player);
    },
    // ...player event

    // or listen state event
    playerStateChanged(playerCurrentState) {
      console.log("player current update state", playerCurrentState);
    },

    // player is ready
    playerReadied(player) {
      console.log("the player is readied", player);
      // you can use it to do something...
      // player.[methods]
    }
  }
};
</script>
<style>
</style>
<style>
#video-slide-component {
  background-color: black;
}
.video-js .vjs-control-bar {
  bottom: -35px;
}
/* .vjs-tech {
  z-index: 650;
}*/
.video-player-custom {
  padding-bottom: 40px;
}
/* .video-slide-controls {
  height: 100%;
} */
</style>
